module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "min-width": "900px"
    }
  }, [(!_vm.orig_module) ? _c('div', [_c('div', {
    staticStyle: {
      "width": "60%",
      "margin": "0 auto"
    }
  }, [_c('el-form', {
    ref: "editForm",
    staticStyle: {
      "background": "#f4f4f4",
      "padding": "30px 20px 20px 20px"
    },
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "试用模块",
      "prop": "title"
    }
  }, [_c('div', {
    staticStyle: {
      "background": "#fff",
      "width": "70%",
      "height": "300px",
      "overflow": "auto"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedCitiesChange
    },
    model: {
      value: (_vm.checkedCities),
      callback: function($$v) {
        _vm.checkedCities = $$v
      },
      expression: "checkedCities"
    }
  }, _vm._l((_vm.cities), function(city) {
    return _c('el-checkbox', {
      key: city,
      staticStyle: {
        "float": "left",
        "clear": "left",
        "margin-left": "20px",
        "position": "relative",
        "top": "0px"
      },
      attrs: {
        "label": city
      }
    }, [_vm._v(_vm._s(city))])
  }), 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "试用期限",
      "prop": "origin"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "position": "relative",
      "left": "47%",
      "top": "80px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.formSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1) : _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('slide-verify', {
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "slider-text": _vm.texts
    },
    on: {
      "success": _vm.onSuccess,
      "fail": _vm.onFail,
      "refresh": _vm.onRefresh
    }
  }), _vm._v(" "), (!_vm.statused) ? _c('span', {
    staticStyle: {
      "position": "relative",
      "top": "40px",
      "color": "#3280fc"
    }
  }, [_vm._v(" 正在等待审核，请等待！")]) : _c('span', {
    staticStyle: {
      "position": "relative",
      "top": "40px",
      "color": "#3280fc"
    }
  }, [_vm._v(" 已授权,请在我的产品查看！")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "position": "relative",
      "top": "80px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.cancelLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelSubmit($event)
      }
    }
  }, [_vm._v("取消试用")])], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ftBox"
  }, [_c('div', {
    staticClass: "ft"
  }, [_c('p', [_vm._v("CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. "), _c('a', {
    staticStyle: {
      "color": "#666"
    },
    attrs: {
      "href": "https://beian.miit.gov.cn/"
    }
  }, [_vm._v("苏ICP备18062906")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2b399a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/individual/trial/TrialList.vue
// module id = 1137
// module chunks = 1